import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const SLIDES = [
  ["/banners/studio.jpg", "Fatturazione elettronica", "Fatture, note di credito e XML FatturaPA controllati con lo schema ufficiale."],
  ["/banners/magazzino.jpg", "Magazzino e DDT", "Articoli, giacenze, documenti di trasporto e ordini fornitori."],
  ["/banners/cassa.jpg", "Corrispettivi e cassa", "Scontrini, chiusura giornaliera e registro dei corrispettivi."],
  ["/banners/agenti.jpg", "Agenti di vendita", "Ordini, preventivi e incassi dal tablet, con calcolo delle provvigioni."],
];

export const HeroSlideshow = () => {
  const [i, setI] = useState(0);
  const [pause, setPause] = useState(false);
  useEffect(() => {
    if (pause) return undefined;
    const t = setInterval(() => setI((n) => (n + 1) % SLIDES.length), 5000);
    return () => clearInterval(t);
  }, [pause]);
  const go = (d) => setI((n) => (n + d + SLIDES.length) % SLIDES.length);
  return (
    <div className="relative aspect-[4/3] w-full overflow-hidden rounded-2xl border border-slate-200 bg-slate-900 shadow-xl" data-testid="hero-slideshow"
      onMouseEnter={() => setPause(true)} onMouseLeave={() => setPause(false)}>
      {SLIDES.map(([src, title, text], n) => (
        <div key={src} className={`absolute inset-0 transition-opacity duration-700 ${n === i ? "opacity-100" : "pointer-events-none opacity-0"}`} data-testid={`hero-slide-${n}`}>
          <img src={src} alt={title} className="h-full w-full object-cover" loading={n === 0 ? "eager" : "lazy"} />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-950/85 via-slate-950/20 to-transparent" />
          <div className="absolute inset-x-0 bottom-0 p-6 text-white">
            <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-sky-300">{String(n + 1).padStart(2, "0")} / {String(SLIDES.length).padStart(2, "0")}</div>
            <h3 className="mt-1 font-display text-2xl font-bold">{title}</h3>
            <p className="mt-1 max-w-sm text-sm text-slate-200">{text}</p>
          </div>
        </div>
      ))}
      {[[-1, ChevronLeft, "left-3", "prev"], [1, ChevronRight, "right-3", "next"]].map(([d, I, pos, id]) => (
        <button key={id} type="button" aria-label={id === "prev" ? "Precedente" : "Successiva"} data-testid={`hero-slide-${id}`} onClick={() => go(d)}
          className={`absolute top-1/2 ${pos} hidden -translate-y-1/2 rounded-full bg-white/80 p-2 text-slate-900 shadow transition-colors hover:bg-white sm:block`}><I className="h-5 w-5" /></button>
      ))}
      <div className="absolute right-5 top-4 flex gap-1.5">
        {SLIDES.map((s, n) => (
          <button key={s[0]} type="button" aria-label={s[1]} data-testid={`hero-dot-${n}`} onClick={() => setI(n)}
            className={`h-2 rounded-full transition-[width,background-color] ${n === i ? "w-6 bg-white" : "w-2 bg-white/50"}`} />
        ))}
      </div>
    </div>
  );
};
